// @ts-nocheck
import {
  CREATE_CLIENT_FAILURE,
  CREATE_CLIENT_REQUEST,
  CREATE_CLIENT_SUCCESS,
  DELETE_CLIENT_FAILURE,
  DELETE_CLIENT_REQUEST,
  DELETE_CLIENT_SUCCESS,
  FETCH_ALL_CLIENTS_FAILURE,
  FETCH_ALL_CLIENTS_REQUEST,
  FETCH_ALL_CLIENTS_SUCCESS,
  SEARCH_CLIENTS_FAILURE,
  SEARCH_CLIENTS_REQUEST,
  SEARCH_CLIENTS_SUCCESS,
  TOGGLE_CLIENT_STATUS_FAILURE,
  TOGGLE_CLIENT_STATUS_REQUEST,
  TOGGLE_CLIENT_STATUS_SUCCESS,
  UPDATE_CLIENT_FAILURE,
  UPDATE_CLIENT_REQUEST,
  UPDATE_CLIENT_SUCCESS,
  APPROVE_CLIENT_TOGGLE_REQUEST,
  APPROVE_CLIENT_TOGGLE_SUCCESS,
  APPROVE_CLIENT_TOGGLE_FAILURE,
} from "../constants/client";

const initialState = {
  clients: [],
  searchString: "",
  isLoading: false,
  statusLoader: false,
  totalPages: 0,
  currentPage: 1,
};

const clientReducer = (state = initialState, action) => {
  switch (action.type) {
    // fetch all clients
    case FETCH_ALL_CLIENTS_REQUEST:
      return {
        ...state,
        searchString: action.payload,
        isLoading: true,
      };
    case FETCH_ALL_CLIENTS_SUCCESS:
      return {
        ...state,
        clients: action.payload?.data,
        isLoading: false,
        totalPages: action?.payload?.meta?.totalPages,
        currentPage: action?.payload?.meta?.currentPage,
      };
    case FETCH_ALL_CLIENTS_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    // create a client
    case CREATE_CLIENT_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case CREATE_CLIENT_SUCCESS:
      return {
        isLoading: false,
        clients: [action.payload, ...state.clients],
      };
    case CREATE_CLIENT_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    // toggle status
    case TOGGLE_CLIENT_STATUS_REQUEST:
      return {
        ...state,
        statusLoader: true,
      };
    case TOGGLE_CLIENT_STATUS_SUCCESS:
      return {
        ...state,
        statusLoader: false,
        clients: state.clients.map((client) => {
          if (client._id === action.payload._id) {
            return action.payload;
          }
          return client;
        }),
      };
    case TOGGLE_CLIENT_STATUS_FAILURE:
      return {
        ...state,
        statusLoader: false,
      };

    // search clinets
    case SEARCH_CLIENTS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case SEARCH_CLIENTS_SUCCESS:
      return {
        ...state,
        clients: action.payload?.data,
        isLoading: false,
        totalPages: action?.payload?.meta?.totalPages,
        currentPage: action?.payload?.meta?.currentPage,
      };
    case SEARCH_CLIENTS_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    // delete client
    case DELETE_CLIENT_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case DELETE_CLIENT_SUCCESS:
      return {
        isLoading: false,
        clients: state.clients.filter(
          (client) => client._id !== action.payload,
        ),
      };
    case DELETE_CLIENT_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    // update clinet
    case UPDATE_CLIENT_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case UPDATE_CLIENT_SUCCESS:
      return {
        isLoading: false,
        clients: state.clients.map((client) => {
          if (client._id === action.payload?._id) {
            return action.payload;
          }
          return client;
        }),
      };
    case UPDATE_CLIENT_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    // approve client
    case APPROVE_CLIENT_TOGGLE_REQUEST:
      return {
        ...state,
        // isLoading: true,
      };
    case APPROVE_CLIENT_TOGGLE_SUCCESS:
      return {
        ...state,
        // isLoading: false,
        clients: state.clients.map((client) =>
          client._id === action.payload?._id
            ? { ...client, ...action.payload }
            : client,
        ),
      };
    case APPROVE_CLIENT_TOGGLE_FAILURE:
      return {
        ...state,
        // isLoading: false,
        error: action.error || "Failed to approve client",
      };
    default:
      return state;
  }
};

export default clientReducer;
export { initialState };